function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25 14.5H28C29.11 14.5 30 15.39 30 16.5V27.5C30 28.61 29.11 29.5 28 29.5H12C10.89 29.5 10 28.61 10 27.5V16.5C10 15.39 10.89 14.5 12 14.5H15V12.5C15 11.39 15.89 10.5 17 10.5H23C24.11 10.5 25 11.39 25 12.5V14.5ZM23 12.5H17V14.5H23V12.5ZM28 27.5H12V25.5H28V27.5ZM12 22.5H28V16.5H25V18.5H23V16.5H17V18.5H15V16.5H12V22.5Z",
  fill: "#979797"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/DiplomatV2.1be77294.svg";
export { SvgComponent as ReactComponent };